module.exports = __webpack_public_path__ + "0b4025741aae16fcf880ffa798ddc321.png";